import { gateway } from "../../../gateway";

export const patchSelectedServices = async (token, data) => {
    try {
        const response = await gateway.put(`/workservices/self`, data, {
            headers: { Authorization: `${token}` },
        });

        return response.data?.data || response.data;
    } catch (error) {
        console.error("Error in patch services", error);
        throw error;
    }
};
